"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RevokeProgrammaticConsentDto = exports.AcceptProgrammaticConsentDto = void 0;
const class_validator_1 = require("class-validator");
const types_1 = require("../../types");
class AcceptProgrammaticConsentDto {
    termsVersion;
    confirmation;
    ownerId;
    acceptedBy;
    acceptedAt;
    revokedAt;
    revokedBy;
    revocationReason;
}
exports.AcceptProgrammaticConsentDto = AcceptProgrammaticConsentDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(100),
    __metadata("design:type", String)
], AcceptProgrammaticConsentDto.prototype, "termsVersion", void 0);
__decorate([
    (0, class_validator_1.IsIn)([types_1.PROGRAMMATIC_CONSENT_CONFIRMATION]),
    __metadata("design:type", Object)
], AcceptProgrammaticConsentDto.prototype, "confirmation", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], AcceptProgrammaticConsentDto.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], AcceptProgrammaticConsentDto.prototype, "acceptedBy", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], AcceptProgrammaticConsentDto.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], AcceptProgrammaticConsentDto.prototype, "revokedAt", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], AcceptProgrammaticConsentDto.prototype, "revokedBy", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], AcceptProgrammaticConsentDto.prototype, "revocationReason", void 0);
class RevokeProgrammaticConsentDto {
    reason;
    termsVersion;
    ownerId;
    acceptedBy;
    acceptedAt;
    revokedAt;
    revokedBy;
    revocationReason;
}
exports.RevokeProgrammaticConsentDto = RevokeProgrammaticConsentDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_validator_1.MaxLength)(500),
    __metadata("design:type", String)
], RevokeProgrammaticConsentDto.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "termsVersion", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "acceptedBy", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "revokedAt", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "revokedBy", void 0);
__decorate([
    (0, class_validator_1.IsEmpty)(),
    __metadata("design:type", void 0)
], RevokeProgrammaticConsentDto.prototype, "revocationReason", void 0);
